// src/StepperForm.tsx
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ApprovalStatus from "../Addenda Wizard Tabs/ApprovalStatusAddenda";
import CreateNewAdddendum from "../Addenda Wizard Tabs/CreateNewAdddendum";
import NotesAddenda from "../Addenda Wizard Tabs/NotesAddenda";
import SummaryAddenda from "../Addenda Wizard Tabs/SummaryAddenda";
import "./SidebarAddenda.css";
import { useFormik } from "formik";
import {
  useCreateProjectAddendaMutation,
  useGetAddendaJobScopeByIdQuery,
  useGetAddendaStatusLookupQuery,
  useLazyGetAddendaByIdQuery,
  useSendEmailOfAddendaMutation,
  useUpdateProjectAddendaMutation,
  useUpsertAddendaJobScopeMutation,
  useUpsertPaymentScheduleAddendaMutation,
} from "../../../../../services/EndPointsApis";
import { toast } from "react-toastify";
import JobScopeAddenda from "../Addenda Wizard Tabs/AddendaJobScope";
import {
  initialValuesAddenda,
  initialValuesAddendaJobScope,
} from "./InitialValuesAddenda";
import PaymentScheduleAddenda from "../Addenda Wizard Tabs/PaymentScheduleAddenda";
import { initialValuesPaymentSchedule } from "../../../Projects/SaleWizardData/InitialValuesSalesWizard";
import DocumentContractual from "../../../Projects/Contractual Review/DocumentContractual";
// import Select from "react-dropdown-select";
const steps = [
  "Addendum Details",
  "Job Scope",
  "Payment Schedule",
  "Documents",
  "Approval Status",
  "Notes",
  "Summary",
];

const SidebarAddenda = ({
  handleDelete,
  selectedIndividualCheckboxId,
  selectedIndividualCheckboxIdPending,
  projectLookups,
  refetch,
  projectId,
  getallActiveUsers,
  togglestepperAssignment,
  closestepper,
  isEditing,
  totalAddendaSaleAmt,
  selectedaddendaguid,
  viewOnly,
  isReviewed,
  isApproved,
  isReviewTitle,


}: any) => {
  const [activeStep, setActiveStep] = useState(0);
  const [addendaId, setAddendaId] = useState('');
  const [addendaIdforJobScope, setAddendaIdForJobScope] = useState('');
  const [statusOfAddenda, setStatusOfAddenda] = useState('')
  const [statusInStatusModule, setStatusInStatusModule] = useState('')
  const [statusToSendInJobScope, setStatusToSendInJobScope] = useState('')
  const [jobScopeCheck, setJobScopeCheck] = useState(false)
  const [documentCheck, setDocumentCheck] = useState(false);
  const [paymentScheduleLoading, setPaymentScheduleLoading] = useState(false);
  const [previousStatusAddenda, setPreviousStatusAddenda] = useState('')

  const [comment, setComment] = useState("");

  const [jobScopeData, setjobScopeData] = useState<Record<string, any> | null>(
    {}
  );
  const [jobScopeDetailsData, setjobScopeDetailsData] = useState<Record<
    string,
    any
  > | null>({});
  const [remainingAmount, setRemainingAmount] = useState("0");
  const [addendaUpdated, setAddendaUpdated] = useState(false);
  const [salePriceAddendaPrice, setSalePriceAddendaPrice] = useState({
    salePrice: 0,
    addendaPrice: 0,
  });
  const [IsPaymentScheduleTrigger, setIsPaymentScheduleTrigger] =
    useState(false);
  const [IsJobScopeTrigger, setIsJobScopeTrigger] = useState(false);
  const [IsAddendaTrigger, setIsAddendaTrigger] = useState(false);
  const [amountPaybaleChange, setAmountPaybaleChange] = useState(false);


  //Upsert addenda job scope Api
  const [
    UpsertJobScope,
    { data, isSuccess: isSuccessJobScope, isLoading: isLoadingJobScope },
  ] = useUpsertAddendaJobScopeMutation();
  //create Addenda
  const [
    createAddenda,
    { data: addendaData, isSuccess, isError, error, isLoading },
  ] = useCreateProjectAddendaMutation();
  const [
    updateAddenda,
    {
      data: UpdateAddendaData,
      isSuccess: isSuccessUpdate,
      isError: isErrorUpdate,
      error: errorUpdate,
      isLoading: isLoadingUpdate
    },
  ] = useUpdateProjectAddendaMutation();
  //   upsert Sale Info
  const [
    UpsertPaymentSchedule,
    { data: UpsertData, isLoading: loadingPaymentSchedule },
  ] = useUpsertPaymentScheduleAddendaMutation();
  //Get Addenda By Id
  const [triggerAddendaById, { data: getAddendaById }] =
    useLazyGetAddendaByIdQuery();
  //send Email Of Addenda
  const [sendEmailOfAddenda, { data: emailOfAddendaData }] =
    useSendEmailOfAddendaMutation();

  //Formik Payment Schedule
  const formikPaymentSchedule = useFormik({
    // validationSchema: LeadsSchema,
    initialValues: initialValuesPaymentSchedule,
    onSubmit: (values) => {

      const transformedValues = Object.values(values).map((value) => ({
        ...value,
        childId: isEditing ? (UpdateAddendaData.result?.addendaId) : (addendaData?.result?.addendaId),
        // childId:addendaData?.result?.addendaId,
        projectId: projectId,
        addendaNbr: value.addendaNbr ? value.addendaNbr : addendaData?.result?.addendaNbr,
        AddendaStatus: statusInStatusModule ?? formik.values.status,
        changeBy: String(value.changeBy) === '' ? 0 : value.changeBy,
      }));
      console.log('transformedValues', transformedValues);

      UpsertPaymentSchedule(transformedValues);
    },
  });

  //formik   job scope
  const formikJobScope = useFormik({
    initialValues: initialValuesAddendaJobScope,
    onSubmit: (values) => {
      UpsertJobScope({
        ...values,
        // addendaId: isEditing ? UpdateAddendaData?.result?.addendaId : addendaData?.result?.addendaId,
        addendaId: UpdateAddendaData?.result?.addendaId || addendaData?.result?.addendaId,
        addendaPreviousStatus: UpdateAddendaData?.result?.addendaStatus || addendaData?.result?.addendaStatus,
        addendaStatus: formik.values.status,
      });
    },
  });

  //Formik Addenda
  const formik = useFormik({
    // validationSchema: LeadsSchema,
    initialValues: initialValuesAddenda,
    onSubmit: (values) => {
      if (selectedaddendaguid && isEditing === true) {
        updateAddenda({ ...values, projectId: projectId });
      } else {
        createAddenda({ ...values, comment: comment, projectId: projectId, amtPayableAcceptance: values.amtPayableAcceptance === '' ? 0 : values.amtPayableAcceptance });
      }
    },
  });

  const { resetForm } = formik;
  const { resetForm: resetFormJobScope } = formikJobScope;
  const { resetForm: resetFormPayment } = formikPaymentSchedule;

  useEffect(() => {
    if (isSuccess && addendaData?.result?.addendaId !==undefined) {
      toast.success(addendaData?.message);
      setAddendaId(addendaData?.result);
      setComment("");
      closestepper();
      refetch();
      formikJobScope.handleSubmit();
      formikPaymentSchedule.handleSubmit();
      setTimeout(() => {
        sendEmailOfAddenda({
          ProjectId: projectId,
          AdendaId: addendaData?.result?.addendaId,
        });
      }, 3000);
    }
  }, [isSuccess, addendaData?.result?.addendaId]);
  useEffect(() => {
    if (isSuccessUpdate && UpdateAddendaData?.result?.addendaId !==undefined) {
      toast.success(UpdateAddendaData?.message);
      setAddendaId(UpdateAddendaData?.result);
      setComment("");
      closestepper();
      refetch();
      formikJobScope.handleSubmit();
      formikPaymentSchedule.handleSubmit();
      setTimeout(() => {
        sendEmailOfAddenda({
          ProjectId: projectId,
          AdendaId: UpdateAddendaData?.result?.addendaId,
        });
      }, 3000);
    }
  }, [isSuccessUpdate, UpdateAddendaData?.result?.addendaId]);

  useEffect(() => {
    if (isSuccessJobScope) {
      closestepper();
      resetForm();
      setAddendaIdForJobScope('')
    }
  }, [isSuccessJobScope]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = "Addenda Not Created";

      if (
        "data" in error &&
        error.data &&
        typeof error.data === "object" &&
        "message" in error.data
      ) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
    if (isErrorUpdate && errorUpdate) {
      let errorMessage: string = "Addenda Not Updated";

      if (
        "data" in errorUpdate &&
        errorUpdate.data &&
        typeof errorUpdate.data === "object" &&
        "message" in errorUpdate.data
      ) {
        errorMessage = (errorUpdate.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, error, isErrorUpdate, errorUpdate]);

  useEffect(() => {
    if (togglestepperAssignment === false && isEditing === false) {
      setActiveStep(0);
      setAddendaId('');
      setTimeout(() => {
        resetForm();
        resetFormJobScope();
        resetFormPayment();
      }, 1000);
      setComment("");
      setAddendaUpdated(false);
      setIsAddendaTrigger(false);
      setIsJobScopeTrigger(false);
      setIsPaymentScheduleTrigger(false);
      setJobScopeCheck(false)
      setDocumentCheck(false)
      // setStatusInStatusModule('')
      setStatusOfAddenda('')
      if (isEditing === false) {
        setPreviousStatusAddenda('')
        setStatusToSendInJobScope('')
      }
    }
  }, [togglestepperAssignment]);

  const isDuplicateOrderId = formikPaymentSchedule?.values?.length !== new Set(formikPaymentSchedule?.values?.map(i => i?.orderId))?.size;

  const getStepContent = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return (
          <CreateNewAdddendum
            isSuccess={isSuccess}
            IsAddendaTrigger={IsAddendaTrigger}
            setAmountPaybaleChange={setAmountPaybaleChange}
            setSalePriceAddendaPrice={setSalePriceAddendaPrice}
            handleDelete={handleDelete}
            addendaUpdated={addendaUpdated}
            setAddendaUpdated={setAddendaUpdated}
            togglestepperAssignment={togglestepperAssignment}
            isEditing={isEditing}
            projectLookups={projectLookups}
            getallActiveUsers={getallActiveUsers}
            formik={formik}
            projectId={projectId}
            addendaId={addendaId}
            selectedAddendaId={selectedaddendaguid}
            comment={comment}
            setStatusOfAddenda={setStatusOfAddenda}
            viewOnly={viewOnly}
            isReviewed={isReviewed}
            isApproved={isApproved}
            setPreviousStatusAddenda={setPreviousStatusAddenda}
            setAddendaIdForJobScope={setAddendaIdForJobScope}
          />
        );
      case 1:
        return (
          <JobScopeAddenda
            IsJobScopeTrigger={IsJobScopeTrigger}
            isEditing={isEditing}
            projectId={projectId}
            projectLookups={projectLookups}
            formik={formikJobScope}
            addendaId={addendaId}
            setjobScopeData={setjobScopeData}
            jobScopeDetailsData={jobScopeDetailsData}
            selectedAddendaId={selectedaddendaguid}
            statusOfAddenda={statusOfAddenda}
            viewOnly={viewOnly}
            isReviewed={isReviewed}
            isApproved={isApproved}
            setJobScopeCheck={setJobScopeCheck}
            jobScopeCheck={jobScopeCheck}
            isReviewTitle={isReviewTitle}
          />
        );
      case 2:
        return (
          <PaymentScheduleAddenda
            addendaData={addendaData}
            setAmountPaybaleChange={setAmountPaybaleChange}
            amountPaybaleChange={amountPaybaleChange}
            IsPaymentScheduleTrigger={IsPaymentScheduleTrigger}
            isEditing={isEditing}
            salePriceAddendaPrice={salePriceAddendaPrice}
            remainingAmount={remainingAmount}
            setRemainingAmount={setRemainingAmount}
            formik={formikPaymentSchedule}
            UpsertPaymentSchedule={UpsertPaymentSchedule}
            formikAddenda={formik}
            projectLookups={projectLookups}
            projectId={projectId}
            totalAddendaSaleAmt={totalAddendaSaleAmt}
            selectedAddendaId={selectedaddendaguid}
            statusOfAddenda={statusOfAddenda}
            viewOnly={viewOnly}
            isReviewed={isReviewed}
            isApproved={isApproved}
            setPaymentScheduleLoading={setPaymentScheduleLoading}
          />
        );
      case 3:
        return (
          <DocumentContractual setDocumentCheck={setDocumentCheck} documentCheck={documentCheck} storeProjectId={projectId} viewOnly={viewOnly} isReviewed={isReviewed} isApproved={isApproved} />
        );
      case 4:
        return (
          <ApprovalStatus
            formik={formik}
            projectLookups={projectLookups}
            projectId={projectId}
            addendaId={selectedaddendaguid}
            statusOfAddenda={statusOfAddenda}
            viewOnly={viewOnly}
            isReviewed={isReviewed}
            isApproved={isApproved}
            isEditing={isEditing}
            isReviewTitle={isReviewTitle}
            setStatusInStatusModule={setStatusInStatusModule}
            setStatusToSendInJobScope={setStatusToSendInJobScope}
          />
        );
      case 5:
        return (
          <NotesAddenda
            formik={formik}
            comment={formik.values.comment}
            setComment={setComment}
            viewOnly={viewOnly}

          />
        );
      case 6:
        return (
          <SummaryAddenda
            formikCreateAddendum={formik}
            totalAddendaSaleAmt={totalAddendaSaleAmt}
            salePriceAddendaPrice={salePriceAddendaPrice}
          />
        );
      default:
        return "Unknown stepIndex";
    }
  };

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      formik.handleSubmit();

      // setTimeout(() => {
      //     formikJobScope.handleSubmit()
      // formikPaymentSchedule.handleSubmit();
      // },1000);
    }
    if (activeStep < steps.length - 1 && activeStep === 0) {
      setjobScopeDetailsData(jobScopeData?.values);
    }
    if (activeStep === 2) {
      setIsPaymentScheduleTrigger(true);
    }
    if (activeStep === 1) {
      setIsJobScopeTrigger(true);
    }
    if (activeStep === 0) {
      setIsAddendaTrigger(true);
    }
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    if (activeStep === 1) {
      setIsJobScopeTrigger(true);
    }
    if (activeStep === 2) {
      setIsPaymentScheduleTrigger(true);
    }
  };

  const validateCurrentStep = () => {
    if (activeStep === 0) {
      const {
        writtenBy,
        addendaType,
        desc,
        internalDesc,
        saleAmount,
        addendaNbr,
        amtPayableAcceptance,
        costAmount,
      } = formik.values;
      const isAddendaTypeSix = addendaType?.id === 6;

      return (
        writtenBy?.id &&
        addendaType?.id &&
        desc &&
        internalDesc &&
        saleAmount &&
        saleAmount &&
        costAmount &&
        (!isAddendaTypeSix || addendaNbr)
        // amtPayableAcceptance &&

      );
    }
    if (activeStep === 4) {
      const { addendaStatus } = formik.values;
      return addendaStatus?.id;
    }
    // if (
    //   activeStep === 4 &&
    //   !viewOnly &&
    //   !isReviewed &&
    //   !isApproved
    // ) {
    //   const { comments } = formik.values;
    //   return comments;
    // }
    return true;
  };

  const isStepValid = validateCurrentStep();
  const isAmountZero = parseFloat(remainingAmount?.replace(/,/g, "")) === 0;
  const isDisabled =
    !isStepValid ||
    isLoading || isLoadingUpdate ||
    (isDuplicateOrderId && activeStep === 2) ||
    (isLoadingJobScope && activeStep === 1) ||
    (isLoading && activeStep === 0) ||
    (loadingPaymentSchedule && activeStep === 2) ||
    (!isAmountZero && activeStep === 2) ||
    (!jobScopeCheck && activeStep === 1 && statusOfAddenda !== "Approved" && statusOfAddenda !== "Reviewed" && !viewOnly) ||
    (!documentCheck && activeStep === 3 && (statusOfAddenda !== "Approved") && !viewOnly) ||
    (viewOnly && activeStep === 6)

  return (
    <>
      <div
        className={
          togglestepperAssignment
            ? "toggle-popup sidebar-popup"
            : "toggle-popup"
        }
      >
        <div className="sidebar-layout custom-wizard">
          <div className="d-flex justify-content-end me-2">
            <button
              className="sidebar-close close-btn-Wizard "
              onClick={closestepper}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="sidebar-header d-flex align-items-center p-2">
            <div className="d-flex">
              <h4>{(isEditing && viewOnly === false && isApproved === false && isReviewTitle === false) ? "Edit Addendum" : (isEditing === true && viewOnly === true) ? 'View Addendum' : (isApproved === true && isEditing === true) ? "Approve Addendum" : (isReviewTitle === true && isEditing === true) ? "Review Addendum" : "New Addendum"} </h4>
            </div>
            <div className="sidebar-footer">
              <div className="submit-button d-flex justify-content-end gap-2">
                <button
                  className="btn btn-light"
                  disabled={activeStep === 0 || paymentScheduleLoading}
                  onClick={handleBack}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleNext}
                  disabled={isDisabled}
                >
                  {activeStep === steps.length - 1 ? "Save" : "Next"}
                </button>
              </div>
            </div>
          </div>
          <div className="toggle-body toggled-body">
            <div className="toggle-height height-inherit">
              <div className="pro-create">
                <Row>
                  <Col>
                    <div className="AddendaWizard">
                      <ul className="list-inline d-flex gap-2 flex-wrap">
                        {steps.map((label, index) => (
                          <React.Fragment key={label}>
                            <li
                              className={`list-inline-item me-0 ${activeStep === index
                                ? "active"
                                : index < activeStep
                                  ? "completed"
                                  : ""
                                }`}
                            >
                              {label}
                            </li>
                            {/* <li className='w-100'>
                                                                <hr style={{ height: "2px", width: "100%" }} />
                                                            </li> */}
                          </React.Fragment>
                        ))}
                      </ul>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>{getStepContent(activeStep)}</Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Container></Container>
    </>
  );
};

export default SidebarAddenda;
